import categoryService from "@/services/categoryService";

const state = {
    categories: [],
}

const actions = {
    getCategories(store, params) {
        return new Promise((resolve, reject) => {
            if (store.state.categories.length > 0) {
                resolve(store.state.categories);
                return;
            }
            categoryService.fetchCategories(params)
                .then((response) => {
                    response.forEach((category) => {
                        category.children.sort((a, b) => b.children.length - a.children.length);
                    });
                    store.commit('setCategories', response);
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

const mutations = {
    setCategories(state, categories) {
        state.categories = categories;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
}